import "./report.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import { Button, CircularProgress } from "@mui/material";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const NoticeReport = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [backEndError, setBackEndError] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  const handleGenerateReport = async (e) => {
    setLoading(true); // Start loading

    try {
      const response = await axios.get(
        `${BASE_URL}/api/report/generateNoticeReport/${userIdRedux}`,
        { responseType: "blob" } // Handle binary response
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "Notice_Board_Report.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      if (response.status === 201) {
        setBackEndError(<font color="green">Success Generating Report</font>);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "There is no data to generate the report";
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>Notice Board Report</h1>
        </div>
        <div className="bottom">
          {/* Button placed on a new line and made bigger */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleGenerateReport}
              variant="contained"
              color="primary"
              style={{
                borderRadius: "15px",
                width: "100%", // Takes full width
                fontSize: "18px", // Larger font size
                padding: "12px", // Larger padding
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Generate Notice Report"
              )}
            </Button>
          </div>

          <span className="error-message">{backEndError}</span>
        </div>
      </div>
    </div>
  );
};

export default NoticeReport;
